module.exports = __webpack_public_path__ + "img/C5.12c9a50f.jpg";